/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import type {MetaType} from '../../../../components/Datatable/Datatable'
import {useNavigate} from 'react-router-dom'
import useModals from '../../../../hooks/useModals'
import {Loading} from '../../../../components/Loading/Loading'
import {GET, PUT} from '../../../../services/api'
import {i18n} from '../../../../translate/i18n'
import {CardFreight} from '../../../../components/CardFreight'

import MapImg from '../../../../assets/freights/map.jpeg'
import RadiusImg from '../../../../assets/freights/radius.jpeg'
import CepImg from '../../../../assets/freights/cep.jpeg'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {Button} from '../../../../components/Button/Button'

type AppConfigType = {
  id: number
  name: string
  type: string
  content: {
    pdv: any
  }
  deliveryType: string
}

const FluxoFreteContent: FC = () => {
  const {showWrapperModal, showDeleteModal, showWarningModal} = useModals()

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [ableItem, setAbleItem] = useState('')
  const [appConfig, setAppConfig] = useState<AppConfigType | null>(null)
  const [appConfigSeller, setAppConfigSeller] = useState<AppConfigType | null>(null)
  const [appConfigWholeSale, setAppConfigWholeSale] = useState<AppConfigType | null>(null)

  const getConfig = async () => {
    try {
      setLoading(true)
      const appRes = await GET(`/appconfig`)
      if (appRes.data && appRes.data.length > 0) {
        const appConfigRes: AppConfigType = appRes.data.find(
          (config: AppConfigType) => config.type === 'qr'
        )
        const appConfigResSeller: AppConfigType = appRes.data.find(
          (config: AppConfigType) => config.type === 'seller'
        )

        const appConfigResWholeSale: AppConfigType = appRes.data.find(
          (config: AppConfigType) => config.type === 'qr_whole_sale'
        )
        if (appConfigRes) {
          setAppConfig(appConfigRes)
          setAbleItem(appConfigRes.deliveryType)
        }

        if (appConfigResSeller) {
          setAppConfigSeller(appConfigResSeller)
        }

        if(appConfigResWholeSale){
          setAppConfigWholeSale(appConfigResWholeSale)
        }

      }
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const activeItem = async (type: string) => {
    setAbleItem(type)
    if (appConfig) {
      const newAppConfig: AppConfigType = {...appConfig}
      newAppConfig.deliveryType = type
      newAppConfig.content.pdv.restrict_cep = type
      await PUT(`/appconfig/${newAppConfig.id}`, {
        deliveryType: newAppConfig.deliveryType,
        content: newAppConfig.content,
      })
      setAppConfig(newAppConfig)
    }
    if (appConfigSeller) {
      const newAppConfig: AppConfigType = {...appConfigSeller}
      newAppConfig.deliveryType = type
      newAppConfig.content.pdv.restrict_cep = type
      await PUT(`/appconfig/${newAppConfig.id}`, {
        deliveryType: newAppConfig.deliveryType,
        content: newAppConfig.content,
      })
      setAppConfig(newAppConfig)
    }
    if (appConfigWholeSale) {
      const newAppConfig: AppConfigType = {...appConfigWholeSale}
      newAppConfig.deliveryType = type
      newAppConfig.content.pdv.restrict_cep = type
      await PUT(`/appconfig/${newAppConfig.id}`, {
        deliveryType: newAppConfig.deliveryType,
        content: newAppConfig.content,
      })
      setAppConfig(newAppConfig)
    }
  }

  useEffect(() => {
    getConfig()
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`delivery_fee.delivery_fee`)}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(
                    `general.fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes`
                  )}
                </span>
              </h3>
            </div>
            <div className='card-body'>
              <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                {/* <p
                  style={{
                    fontWeight: 700,
                    lineHeight: '1.5rem',
                    color: '#3C9EE5',
                    cursor: 'pointer',
                  }}
                  onClick={() => navigate('/configuracoes/taxa-entrega')}
                >
                  {i18n.t(`frenet.back`)}
                </p> */}
              </div>
              <div className='d-flex flex-row flex-wrap gap-7'>
                <CardFreight
                  name={i18n.t(`freight.map`)}
                  description={<p>{i18n.t(`freight.map_text`)}</p>}
                  activeItem={activeItem}
                  able={ableItem === 'mapa'}
                  type='mapa'
                  image={MapImg}
                  key={1}
                  link='/configuracoes/taxa-entrega/map'
                />
                <CardFreight
                  name={i18n.t(`freight.range`)}
                  description={<p>{i18n.t(`freight.range_text`)}</p>}
                  activeItem={activeItem}
                  able={ableItem === 'area'}
                  type='area'
                  image={RadiusImg}
                  key={2}
                  link='/configuracoes/taxa-entrega/raio'
                />
                <CardFreight
                  name={i18n.t(`freight.cep`)}
                  description={<p>{i18n.t(`freight.cep_text`)}</p>}
                  activeItem={activeItem}
                  able={ableItem === 'cep'}
                  type='cep'
                  image={CepImg}
                  key={3}
                  link='/configuracoes/taxa-entrega/cep'
                />
              </div>
              <div className='pt-8'>
                <Button
                  text={i18n.t('buttons.back')}
                  color='info'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate('/configuracoes/taxa-entrega')}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const FluxoFrete: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`freight.title`), path: 'configuracoes/taxa-entrega', isActive: true},
        ]}
      >
        {i18n.t(`freight.title`)}
      </PageTitle>
      <FluxoFreteContent />
    </>
  )
}

export {FluxoFrete}
